import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Space, Typography, Breadcrumb, Divider, Grid } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import Pict from '../../assets/img/group.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function About() {
  let { xs, lg } = useBreakpoint()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>About</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col xs={24} md={12} style={{ paddingBottom: 16 }}>
          <Image
            width={'100%'}
            src={Pict}
            preview={false}
            style={{ objectFit: 'cover' }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Aims and Scope</Text>
            <Text style={{ fontSize: 15 }}>The First World Conference on Health and Social Science is the First International conference involving 3 Faculties of Binawan University. It is planned as an annual event. This acitivity is supported by DRTPM (The Directorate of Research, Technology, and Community Service) funding. This activity aims to develop and evaluate research-based interventions to improve public health, reduce social inequalities in health, and communicate research results and implications to wide range of audiences.</Text>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Scientific Committees</Text>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Prof. Vidhya Venugopal (Sri Ramachandra Institute of Higher Education and Research, India)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Prof. Dr. Ir. Illah Sailah, M.S. (Binawan University, Indonesia)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Dr. Aliana Dewi, SKp, MN. (Binawan University, Indonesia)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Mia Srimiati, S.Gz., M.Si (Binawan University, Indonesia)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Ervina Maulida, S.Pd., MBA (Binawan University, Indonesia)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Maryuni, SKM, MKM (Binawan University, Indonesia)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Prof. Chen, J.V (National Cheng Kung University, Taiwan)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>dr. Anna Suraya, MKK, SpOk (K), Ph.D. (Binawan University, Indonesia)</Text>
            </Space>
            <Space>
              <CheckCircleFilled style={{ color: '#0D6E49' }} />
              <Text style={{ fontSize: 16 }}>Prof. Dr. Ikenna Ebuenyi (University of Pittsburgh, USA)</Text>
            </Space>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Row style={{ textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Organizing Committee</Text>
            </Col>
          </Row>
          <Row gutter={[0,16]} style={{ marginTop: 64 }}>
            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Standing Committee</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Prof. Dr.Ir. Illah Sailah, M.S.</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Aliana Dewi, SKp, MN.</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Mia Srimiati, S.Gz., M.Si.</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Ir. Firdaus Basbeth MM, PMA CIQAR, CIQNR</Text>
                  <Text style={{ fontSize: 16 }}>Maryuni, SKM, MKM</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Internasional Advisors</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Prof. Vidhya Venugopal (Sri Ramachandra Institute of Higher Education and Research)</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Koordinator</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>dr. Anna Suraya, MKK, SpOk (K), Ph.D.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Tim Sponsor</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dr. Uci Sulandari, S.Si, M.Si.</Text>
                  <Text style={{ fontSize: 16 }}>Muhammad Rizki Kurniawan, S.Si, M.Si.</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Aan Sutandi, S.Kep., M.N.</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Ir. Bambang Sulistyo P, M.KKK</Text>
                  <Text style={{ fontSize: 16 }}>Dinni Randayani Lubis, S.ST, M.Kes</Text>
                  <Text style={{ fontSize: 16 }}>Krismayadi, S.Si., M.M.</Text>
                  <Text style={{ fontSize: 16 }}>Eggy Widya Larasati SST., M. Keb</Text>
                  <Text style={{ fontSize: 16 }}>Yuli Utami, Skp, MN</Text>
                  <Text style={{ fontSize: 16 }}>Yunita Sari Purba, SST.K3., MA</Text>
                  <Text style={{ fontSize: 16 }}>Noraeni Arsyad, SST.Ft,. M.Pd</Text>
                  <Text style={{ fontSize: 16 }}>Apt. Ernie Halimatushadyah, S.Farm., M.Farm.</Text>
                  <Text style={{ fontSize: 16 }}>Etyca Rizky Yanti SE, MM.</Text>
                  <Text style={{ fontSize: 16 }}>Imam Kautsar, S.E., M.Comp.Stud.</Text>
                  <Text style={{ fontSize: 16 }}>Uut Hanafi Rochman, SST, Sp.P.S.B</Text>
                  <Text style={{ fontSize: 16 }}>Ratnasartika Aprilyani, S.Psi., M.Si., Psikolog</Text>
                  <Text style={{ fontSize: 16 }}>Isti Istianah, Amd Gz., SGz., MKM</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Administrasi Kesekretariatan</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Putri Winda Lestari S.KM, M.Kes (epid)</Text>
                  <Text style={{ fontSize: 16 }}>Tri Rahayu, SE.</Text>
                  <Text style={{ fontSize: 16 }}>Dian Rachma Wijayanti, M.Sc.</Text>
                  <Text style={{ fontSize: 16 }}>Dini Nur Fadillah M.Pd.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Tim Tema dan speakers</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Ns. Agung Setiyadi, S.Kep, MSN</Text>
                  <Text style={{ fontSize: 16 }}>Harini Fajar Ningrum, MM</Text>
                  <Text style={{ fontSize: 16 }}>Lina Agestika, SGz., MHSc.</Text>
                  <Text style={{ fontSize: 16 }}>Puji Astuti Wiratmo S.Kep, M.N</Text>
                  <Text style={{ fontSize: 16 }}>Apt.Dwi Puspita Sari.M.Farm</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Tim Publikasi Ilmiah</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dr. Renan Prasta Jenie, STP, MT</Text>
                  <Text style={{ fontSize: 16 }}>Ahmad Fitra Ritonga, S.Pd., M.Si</Text>
                  <Text style={{ fontSize: 16 }}>Ns Apriana Rahmawati, S.Kep., M.Kep</Text>
                  <Text style={{ fontSize: 16 }}>Dr. dr Sandra Hakiem, SKed, M.Si</Text>
                  <Text style={{ fontSize: 16 }}>Ois Nurcahyanti S.Pd, M.Si</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Tim Acara/Penyelenggaraan</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Ervina Maulida, S.Pd, MBA</Text>
                  <Text style={{ fontSize: 16 }}>Jimny Hilda Fauzia, M.Psi., Psikolog</Text>
                  <Text style={{ fontSize: 16 }}>Angga Rizqiawan, S.Gz., M.Si</Text>
                  <Text style={{ fontSize: 16 }}>Irwanti Gustina, SST,Mkes</Text>
                  <Text style={{ fontSize: 16 }}>Mari Esterilita, S. Tr. Sos,Sp.P. S.A.</Text>
                  <Text style={{ fontSize: 16 }}>Puspitasari Nurul D.P,S. Tr. Sos.,Sp.P. S.D</Text>
                  <Text style={{ fontSize: 16 }}>Firman Zaenudin</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Tim Partisipan</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Syafrima Wahyu, M.Si</Text>
                  <Text style={{ fontSize: 16 }}>Hikmah Rahmah, M.Si.</Text>
                  <Text style={{ fontSize: 16 }}>Shenda Maulina Wulandari S.Kep., M.Kep</Text>
                  <Text style={{ fontSize: 16 }}>Langgo Bramandityo</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Tim IT</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Muhammad Arif Abdul Hakim, S.SI, MMSI.</Text>
                  <Text style={{ fontSize: 16 }}>Anita Rismayani Puti Darma, S.Ds</Text>
                  <Text style={{ fontSize: 16 }}>Dicky Dewantoro S.Kom</Text>
                  <Text style={{ fontSize: 16 }}>Darmawan Syahputra Sukarame, S.Pd.</Text>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default About